import { useState } from "react";
import api from "../api/axiosInstance";
import { AuthAlert } from "./AuthLayout";

// "Resend verification email" button with its own success/error message.
// Used on the Register "check your email" screen, the Login page (when the
// account isn't verified yet) and the Verify Email page (expired link).
//
// Pass `email` when you already know it. If it's empty, a small email field
// is shown so the user can type it (e.g. when they open an expired link).
export default function ResendVerification({ email = "", label = "Resend verification email" }) {
  const [typedEmail, setTypedEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [tone, setTone] = useState("success");

  const targetEmail = (email || typedEmail).trim();

  const handleResend = async () => {
    if (!targetEmail) {
      setTone("error");
      setMessage("Enter your email address first.");
      return;
    }

    setLoading(true);
    setMessage("");
    try {
      const res = await api.post("/user/resend-verification", { email: targetEmail });
      setTone("success");
      setMessage(res.data.message);
    } catch (err) {
      setTone("error");
      setMessage(err.response?.data?.message || "Could not send the email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="au-field">
      {!email && (
        <>
          <label className="au-label" htmlFor="resend-email">Email</label>
          <input
            id="resend-email"
            className="au-input"
            type="email"
            value={typedEmail}
            onChange={(e) => setTypedEmail(e.target.value)}
            placeholder="you@hirepeaksconsulting.com"
            autoComplete="email"
          />
        </>
      )}

      <button
        type="button"
        className="au-link-small au-resend"
        onClick={handleResend}
        disabled={loading}
      >
        {loading ? "Sending..." : label}
      </button>

      {message && <AuthAlert tone={tone}>{message}</AuthAlert>}
    </div>
  );
}